/*
 * @Description:数字金额百分比计算字段 千分符 省略末尾0
 * @Version: 2.0
 * @Autor: 纪楠楠 jinannan@qfei.cn
 * @Date: 2025-03-05 10:22:11
 * @LastEditors: 纪楠楠 jinannan@qfei.cn
 */
import { ref } from 'vue';
import { tools } from '@/utils/tools';
export default function useThousandOption() {
  const precisionNum = ref(0);
  // 判断是否是21   此处兼容三种格式  sub.setting?.fieldExt   sub?.fieldExt      sub.targetExt
  const getIsFieldType21Ext = (sub) => {
    let fieldExt;
    let fieldType;
    if (sub?.fieldExt || sub.targetExt) {
      fieldExt = sub?.fieldExt || sub.targetExt;
      fieldType = sub?.fieldType || sub.targetFieldType;
    } else if (sub?.setting?.fieldType !== 21) {
      fieldExt = sub.setting?.fieldExt;
      fieldType = sub.setting?.fieldType;
    } else {
      fieldExt = sub.setting?.business?.fieldExt;
      fieldType = sub.setting?.business?.fieldType;
    }
    return { fieldExt, fieldType };
  };

  // 千分符处理
  const isShowThousandFormatter = (event, sub) => {
    return tools.isShowThousandFormatter(event, getIsFieldType21Ext(sub)?.fieldExt, getIsFieldType21Ext(sub)?.fieldType);
  };

  // 处理精度
  const getPrecisionNum = (e, sub = null) => {
    if (sub) {
      precisionNum.value = tools.getZeros(e, getIsFieldType21Ext(sub)?.fieldExt);
    }
  };
  // 获取精度
  const getPrecision = (sub, precisionNum, getDataType = false) => {
    if (!sub) {
      return 0;
    }
    const targetExt = getIsFieldType21Ext(sub)?.fieldExt;
    // 对目标扩展字段进行 JSON 解析和条件判断
    if (tools.isJSON(targetExt)) {
      const parsed = JSON.parse(targetExt);
      if (parsed.isZero === true) {
        return precisionNum;
      }
      return Number(getDataType ? parsed.dataType : parsed.numberFormat);
    } else if (tools.isNumberOrStringNumber(targetExt)) {
      return getDataType ? 2 : Number(targetExt);
    } else if (typeof targetExt === 'object' && targetExt !== null) {
      if (targetExt?.isZero === true) {
        return precisionNum;
      }
      return Number(getDataType ? targetExt.dataType : targetExt.numberFormat);
    } else {
      return 2;
    }
  };

  return {
    precisionNum,
    getIsFieldType21Ext,
    isShowThousandFormatter,
    getPrecisionNum,
    getPrecision
  };
}
